// Utils
import { getArrayOfPropertyValuesFromObjectsInTheArray, } from '../../arrays/getArrayOfPropertyValuesFromObjectsInTheArray';
import { isPrimitive, isEmpty } from '../../others';
import { getPropertiesFromObject } from '../getPropertiesFromObject';
/**
 * @description Get array of values from any object, calling appropriate function depends on object type and collect values
 *
 * @param {any} obj
 * @param {string[]} keysToFind - array of keys to find on target object
 *
 * @example
 * getArrayOfValues({target: 1, key: 2}, ['target', 'key']);
 * // return [{target: 1, key: 2}]
 *
 * getArrayOfValues([{target: 1}, {target: {a : 15}}, {target: 'test'}], ['target']);
 * // return [{ target: 1 }, { target: {a : 15} }, { target: 'test' }]
 *
 * @returns {any[]}
 */
export var getArrayOfValues = function (obj, keysToFind) {
    if (isPrimitive(obj)) {
        return [];
    }
    if (Array.isArray(obj)) {
        return getArrayOfPropertyValuesFromObjectsInTheArray(obj, keysToFind);
    }
    var value = getPropertiesFromObject(obj, keysToFind);
    return !isEmpty(value) ? [value] : [];
};
//# sourceMappingURL=getArrayOfValues.js.map